export const isNonEmptyArray = (arr) => Array.isArray(arr) && arr.length > 0;
